import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

function ChartComponent({ chartData }) {
  return (
    <ResponsiveContainer width="100%" height={400} minWidth="100%">
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="color1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#5272AA" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#5272AA" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A3B3F9" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A3B3F9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8EEED7" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8EEED7" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color4" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#87A1D1" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#87A1D1" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <YAxis axisLine={false} tick={false} />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="WAITING FOR PAYMENT"
          stackId="1"
          stroke="#5272AA"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color1)"
        />
        <Area
          type="monotone"
          dataKey="PAID"
          stackId="2"
          stroke="#A3B3F9"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color2)"
        />
        <Area
          type="monotone"
          dataKey="EXPIRED REFERENCE NUMBER"
          stackId="4"
          stroke="#87A1D1"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color4)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

ChartComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default ChartComponent;
